import { IonButton, IonCol, IonIcon, IonRow } from "@ionic/react";
import "./ListItemDamage.css";
import { arrowBackOutline, eyeOutline, warning } from "ionicons/icons";

interface ListItemDamageProps {
  itemNumber: number;
  label: string;
  value: string;
  onClick?: () => void;
  color?: "error" | "warning";
}

let colorValues = {
  error: "#dd4515",
  warning: "yellow",
};

const ListItemDamage: React.FC<ListItemDamageProps> = ({
  itemNumber,
  label,
  value,
  color = "error",
  onClick,
}) => {
  return (
    <IonRow
      className="ListItemDamage "
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <div className="ListItemDamage-content">
        <div
          className="ListItemDamage-dot"
          style={{ backgroundColor: colorValues[color] }}
        ></div>
        <div className="ListItemDamage-number">{itemNumber}.</div>
        <div className="ListItemDamage-text">
          {label} : <span className="ListItemDamage-text_value">{value}</span>
        </div>
      </div>
      <IonIcon icon={eyeOutline} className="ListItemDamage-icon" />
    </IonRow>
  );
};

export default ListItemDamage;
